import { baseApiClient } from "data/modules/api/api.client";
import { FETCH_PLAN_WHITELABEL_API } from "features/Account/Account.constants";
import { useAccountStore } from "features/Account/store/useAccountStore";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { isRequestSuccessful } from "utils/Utils";

export const useWhitelabelFeatures = () => {
  const whitelabelFeatures = useAccountStore(
    (state) => state.whitelabelFeatures
  );
  const setWhitelabelFeatures = useAccountStore(
    (state) => state.setWhitelabelFeatures
  );

  const fetchWhitelabelFeatures = async () => {
    if (checkIsArrayEmpty(whitelabelFeatures)) {
      const response = await baseApiClient.get(FETCH_PLAN_WHITELABEL_API);
      if (isRequestSuccessful(response?.status)) {
        const features =
          response?.data?.data?.purchasable_whitelabel_items ?? [];

        if (!checkIsArrayEmpty(features)) {
          setWhitelabelFeatures(features);
          return features;
        }
      }
    } else {
      return whitelabelFeatures;
    }
  };

  return {
    fetchWhitelabelFeatures,
  };
};
